import type { TimeRange } from 'tacho-activity-chart';

const DAY = 24 * 60 * 60;

/**
 * The diagram API only returns whole UTC day buckets, so a local day at a
 * positive UTC offset is missing its first hours and a negative offset is
 * missing its last hours. Fetch one extra day on each side and let
 * `toChartData` clip the result back to the requested period.
 */
export function padDiagramPeriod(period: TimeRange, paddingSeconds = DAY): TimeRange {
  return {
    start: period.start - paddingSeconds,
    end: period.end + paddingSeconds,
  };
}

/** Keeps only the API day buckets that fall inside the originally requested period. */
export function filterDiagramDays<T extends { day?: unknown }>(
  days: T[] | null | undefined,
  period: TimeRange,
): T[] {
  // Compare UTC calendar days, not bucket instants: a bucket can start at an
  // hour other than midnight when the caller sends an hour range.
  const from = Math.floor(period.start / DAY);
  const to = Math.floor(period.end / DAY);

  return (Array.isArray(days) ? days : []).filter((day) => {
    const value = Number(day?.day);
    return Number.isFinite(value) && Math.floor(value / DAY) >= from && Math.floor(value / DAY) <= to;
  });
}
